import InputItemList from '@shared/components/core/field/list/TextInputList';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IClientAuthRedirectEditorProps {
    additionalRedirectUris: string[];
    authCodeRedirectUrlHost: string | undefined;
    onUpdate: (
        additionalField: 'additionalRedirectUris',
        additionalValue: string[],
        hostField: 'authCodeRedirectUrlHost',
        hostValue: string | undefined
    ) => void;
}

export default function ClientAuthRedirectEditor({
    additionalRedirectUris,
    authCodeRedirectUrlHost,
    onUpdate,
}: IClientAuthRedirectEditorProps) {
    const { t } = useTranslation();

    // Compute combined values directly - no state needed
    const displayValues = useMemo(() => {
        return authCodeRedirectUrlHost
            ? [authCodeRedirectUrlHost, ...additionalRedirectUris]
            : [...additionalRedirectUris];
    }, [authCodeRedirectUrlHost, additionalRedirectUris]);

    const handleChange = (updatedUris: string[]) => {
        // Split back into host (first item) and additional (rest)
        const newHost = updatedUris.length > 0 ? updatedUris[0] : undefined;
        const newAdditional = updatedUris.slice(1);

        onUpdate('additionalRedirectUris', newAdditional, 'authCodeRedirectUrlHost', newHost);
    };

    return (
        <InputItemList
            initialValues={displayValues}
            legend={t('common:organization.projects.authRedirect.title')}
            description={t('common:organization.projects.authRedirect.description')}
            onChange={handleChange}
        />
    );
}
